import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const NoAccess = () => {
  const logoSrc   = `${process.env.PUBLIC_URL}/utmlogo.svg`;
  const navigate  = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      px={2}                         /* responsive horizontal padding */
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },       /* tighter padding on mobile */
          textAlign: "center",
          maxWidth: 480,
          width: "100%",
        }}
      >
        {/* Brand logo */}
        <Box
          component="img"
          src={logoSrc}
          alt="UTM Logo"
          sx={{ maxWidth: 140, mb: 3 }}
        />

        {/* Headline */}
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          403 – No Access
        </Typography>

        {/* Explanation */}
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Uh-oh. You don’t have permission to view this file. If you think this is a
          mistake, please contact your administrator for access.
        </Typography>

        {/* Primary action – go back */}
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 1 }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>

        {/* Secondary action – go home */}
        <Button
          component={Link}
          to="/"
          variant="text"
          fullWidth
          sx={{ mt: 1 }}
        >
          Home
        </Button>
      </Paper>
    </Box>
  );
};

export default NoAccess;
